import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { isNewState } from 'client/site-modules/shared/utils/publication-states';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';

export function CoreButton({ makeSlug, modelSlug, submodelSlug, year, publicationState, makeName, modelName }) {
  if (!(makeSlug && modelSlug && year && publicationState)) {
    return null;
  }

  let ctaText = 'Custom Appraisal';
  let url = `/${makeSlug}/${modelSlug}/${year}/appraisal-value`;
  let trackingId = 'mmy_select_submit_mmyt';

  if (isNewState(publicationState)) {
    ctaText = 'Pricing & Review';
    url = getCoreUrl({ makeSlug, modelSlug, submodelSlug, year });
    trackingId = 'comparator_core_link';
  }

  const ymmName = `${year} ${makeName} ${modelName}`;

  return (
    <Button
      className="core-btn py-0_5 px-1 fw-normal text-transform-none"
      size="lg"
      color="outline-primary-b"
      tag={Link}
      to={url}
      data-tracking-id={trackingId}
      aria-label={`${ctaText} for ${ymmName}`}
    >
      {ctaText}
    </Button>
  );
}

CoreButton.propTypes = {
  makeSlug: PropTypes.string,
  modelSlug: PropTypes.string,
  submodelSlug: PropTypes.string,
  publicationState: PropTypes.string,
  year: PropTypes.number,
  makeName: PropTypes.string,
  modelName: PropTypes.string,
};

CoreButton.defaultProps = {
  styleId: null,
  makeSlug: null,
  modelSlug: null,
  submodelSlug: null,
  publicationState: null,
  year: null,
  makeName: null,
  modelName: null,
};
